import * as types from './action-types'

export const mouseEnterNav = () => ({
  type: types.MOUSE_ENTER_NAV
})

export const navOverArtists = () => ({
  type: types.NAV_OVER_ARTISTS
})

export const navOutArtists = () => ({
  type: types.NAV_OUT_ARTISTS
})



// WEBPACK FOOTER //
// ./src/components/navigation/actions.js